import React from "react";

export default function FooterPrescription({ clinicDetails, doctorData }) {
  return (
    <div style={{ width: "100%", boxSizing: "border-box" }}>
      {clinicDetails?.prescription_FooterYN ===
      "Y" ? null : clinicDetails?.prescription_FooterYN === "C" ? (
        <div
          dangerouslySetInnerHTML={{
            __html: atob(doctorData.footerDetails).replace(
              /className=/g,
              "class="
            ),
          }}
        />
      ) : clinicDetails?.prescription_FooterYN === "N" ? (
        <div
          style={{ height: `${clinicDetails.prescription_Footer_Space}px` }}
        />
      ) : null}

      <div
        style={{
          marginTop: 12,
          fontSize: 12,
          color: "#374151",
          marginBottom: 0,
        }}
      >
        <strong>Disclaimer</strong>: This prescription has been issued via
        telemedicine based on the information provided by the patient. In case
        of any emergency or worsening symptoms, please consult a doctor in
        person or visit the nearest healthcare facility immediately.
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: 8,
          fontSize: 11,
        }}
      >
        <div>© Powered by Doxzon</div>
      </div>
    </div>
  );
}
